module.exports = __webpack_public_path__ + "static/AddYourDomain-f715d7c7572d000b7ed57b3f46837b58.png";